import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { PresentationGlobalComponent, SlideObject } from '../types';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';
import GlobalComponentPreview from './GlobalComponentPreview';

interface GlobalComponentsPanelProps {
  components: PresentationGlobalComponent[];
  selectedObjects: SlideObject[];
  canManage: boolean;
  canPlace: boolean;
  onSave: (name: string) => Promise<void>;
  onPlace: (id: string) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}

const GlobalComponentsPanel: React.FC<GlobalComponentsPanelProps> = ({
  components,
  selectedObjects,
  canManage,
  canPlace,
  onSave,
  onPlace,
  onDelete,
}) => {
  const [name, setName] = useState('');
  return (
    <Box sx={{ p: 2 }}>
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.title, color: PRES.textPrimary, mb: 1 }}>
        {COPY.globalComponents}
      </Typography>
      {canManage && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
          <TextField size="small" value={name} onChange={(event) => setName(event.target.value)} placeholder={COPY.name} />
          <Button
            disabled={!name.trim() || selectedObjects.length < 1}
            onClick={async () => {
              await onSave(name.trim());
              setName('');
            }}
            sx={{ textTransform: 'none' }}
          >
            {COPY.saveGlobal}
          </Button>
        </Box>
      )}
      {components.map((component) => (
        <Box key={component._id} sx={{ mb: 1.25, p: 1, border: `1px solid ${PRES.borderSubtle}`, borderRadius: 1 }}>
          <Box sx={{ mb: 1 }}>
            <GlobalComponentPreview id={component._id} objects={component.objects || []} />
          </Box>
          <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body }}>{component.name}</Typography>
          <Box sx={{ display: 'flex', gap: 1, mt: 0.75 }}>
            {canPlace && (
              <Button size="small" onClick={() => void onPlace(component._id)} sx={{ textTransform: 'none' }}>
                {COPY.placeGlobal}
              </Button>
            )}
            {canManage && (
              <Button size="small" color="error" onClick={() => void onDelete(component._id)} sx={{ textTransform: 'none' }}>
                {COPY.delete}
              </Button>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default GlobalComponentsPanel;
